import asyncComponent from 'Demora/AsyncComponent';

const blog = asyncComponent(
	() => import(/* webpackChunkName: "blog" */ '../../js/components/Blog/blog')
);

const PublicCampaignPost = asyncComponent(
	() =>
		import(
			/* webpackChunkName: "PublicCampaignPost" */ '../../js/components/public_campaign_post/PublicCampaignPost'
		)
);

import SocialRoutes from '../../../../vendor/z5internet/react-social/src/resources/assets/js/src/app/NoAuth/Routes';

const viewPlan = asyncComponent(
	() =>
		import(
			/* webpackChunkName: "viewPlan" */ '../../js/components/plan/viewPlan'
		)
);

import WebinarRoutes from '../../../../vendor/z5internet/webinar/src/resources/assets/js/components/NoAuth/Routes';

const reloadScreen = asyncComponent(
	() =>
		import(
			/* webpackChunkName: "reloadScreen" */ '../../js/components/reloadScreen'
		)
);

const thankYou = asyncComponent(
	() =>
		import(
			/* webpackChunkName: "prot-thank-you" */ '../../js/components/upgrade/thank_you'
		)
);

export default SocialRoutes.concat(
	WebinarRoutes.concat([
		{
			path: '/blog/:bid?',
			component: blog,
		},
		{
			path: '/public_campaign_post/:pid',
			component: PublicCampaignPost,
		},
		{
			path: '/settings/emailSettings1',
			component: asyncComponent(
				() =>
					import(
						/* webpackChunkName: "emailOptions" */ '../../js/components/email/emailOptions'
					)
			),
		},
		{
			path: '/upgrade/cp_payment',
			component: thankYou,
		},
		{
			path: '/users/home/cb/return/return1.php',
			component: asyncComponent(
				() =>
					import(
						/* webpackChunkName: "upgReturn1" */ '../../js/components/upgrade/pay/Upg2'
					)
			),
		},
		{
			path: '/viewPlan/:id/:code',
			component: viewPlan,
		},
		{
			path: '/clikpost/earn',
			component: reloadScreen,
		},
		{
			path: '/earn_t',
			component: asyncComponent(
				() =>
					import(
						/* webpackChunkName: "launch_teaser" */ 'resources/assets/js/components/launch_teaser/launch_teaser'
					)
			),
		},
	])
);
